//@ts-nocheck
import React, {useState} from 'react'
import * as Yup from 'yup'
import {useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import axios from 'axios'
import {BASE_URL} from '../../../../../../api'
import useAdmin from '../../../../../hooks/useAdmin'

const profileDetailsSchema = Yup.object().shape({
  name: Yup.string(),
  email: Yup.string(),
  company: Yup.string(),
  companySite: Yup.string(),
  country: Yup.string(),
  password: Yup.string().min(6).max(20),
  confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
})

let a = {}

//@ts-ignore
// export const nameVar = makeVar('')
const ProfileDetails = ({data}: any) => {
  // const [updateSubAdminDetails, response] = useUpdateSubAdminDetailsMutation()
  const [showModal, setShowModal] = useState(false)
  const [message, setMessage] = useState('')
  Object.assign(a, data)

  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    //@ts-ignore
    initialValues: {
      name: data.name || '',
      email: data.email || '',
      company: a.company || 'Enforma',
      companySite: a.companySite || 'Enforma.com',
      country: a.country || 'Mexico',
    },
    enableReinitialize: true,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true)
        const response = await axios.put(`${BASE_URL}/admin/${data._id}`, {
          username: values.name,
          email: values.email,
          company: values.company,
          companySite: values.companySite,
          country: values.country,
        })
        console.log('Response update:', response.data)

        formik.resetForm()

        setMessage('Updated Successfully')
      } catch (e) {
        setError(true)
        setMessage(e.data)
      } finally {
        setLoading(false)
        setShowModal(true)
      }
    },
  })

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_profile_details'
          aria-expanded='true'
          aria-controls='kt_account_profile_details'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Profile Details</h3>
          </div>
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Full Name</label>

                <div className='col-lg-8'>
                  <div className='row'>
                    <div className='col-lg-6 fv-row'>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder='First name'
                        {...formik.getFieldProps('name')}
                      />
                      {formik.touched.name && formik.errors.name && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.name}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Email</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Email'
                    {...formik.getFieldProps('email')}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.email}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Company</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Company'
                    {...formik.getFieldProps('company')}
                  />
                  {formik.touched.company && formik.errors.company && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.company}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Company Site</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Company Site'
                    {...formik.getFieldProps('companySite')}
                  />
                  {formik.touched.companySite && formik.errors.companySite && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.companySite}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Country</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Country'
                    {...formik.getFieldProps('country')}
                  />
                  {formik.touched.country && formik.errors.country && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.country}</div>
                    </div>
                  )}
                </div>
              </div>

              {/* <div className='row mb-6'>
              
            </div>

            <div className='row mb-6'>
            </div> */}
            </div>

            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button type='submit' className='btn btn-primary' disabled={false}>
                {'Save Changes'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      {showModal && (
        <MessageModal
          showModal={showModal}
          setShowModal={setShowModal}
          message={message}
          error={error}
        />
      )}
      <SignInMethod data={data} />
    </>
  )
}
const passwordFormValidationSchema = Yup.object().shape({
  currentPassword: Yup.string('current password is required'),
  newPassword: Yup.string('password is required')
    .min(6, 'new password should atleast be 6 characters long')
    .max(20),
  passwordConfirmation: Yup.string().oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
})

const SignInMethod = ({data}: any) => {
  const [showModal, setShowModal] = useState(false)
  const [message, setMessage] = useState('')

  const [passwordLoading, setPasswordLoading] = useState(false)

  const [error, setError] = useState(false)
  const {updateAdminPassword} = useAdmin()
  const id = data?._id
  const formik2 = useFormik({
    initialValues: {
      currentPassword: '',
      newPassword: '',
      passwordConfirmation: '',
    },
    validationSchema: passwordFormValidationSchema,
    onSubmit: async (values) => {
      try {
        setPasswordLoading(true)
        const response = await updateAdminPassword(id, values.currentPassword, values.newPassword)
        console.log('Response update:', response.data)

        formik2.resetForm()
        setMessage('Password updated successfully!')
      } catch (e) {
        setMessage('Password update failed!')
      } finally {
        setPasswordLoading(false)
        setShowModal(true)
      }
    },
  })

  const showPasswordForm = true
  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_signin_method'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Reset Password</h3>
        </div>
      </div>

      <div id='kt_account_signin_method' className='collapse show'>
        <div className='card-body border-top p-9'>
          <div className='d-flex flex-wrap align-items-center mb-10'>
            <div id='kt_signin_password' className={' ' + (showPasswordForm && 'd-none')}>
              <div className='fs-6 fw-bolder mb-1'>Password</div>
              <div className='fw-bold text-gray-600'>************</div>
            </div>

            <div
              id='kt_signin_password_edit'
              className={'flex-row-fluid ' + (!showPasswordForm && 'd-none')}
            >
              <form
                onSubmit={formik2.handleSubmit}
                id='kt_signin_change_password'
                className='form'
                noValidate
              >
                <div className='row mb-1'>
                  <div className='col-lg-4'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='currentpassword' className='form-label fs-6 fw-bolder mb-3'>
                        Current Password
                      </label>
                      <input
                        type='password'
                        className='form-control form-control-lg form-control-solid '
                        id='currentpassword'
                        {...formik2.getFieldProps('currentPassword')}
                      />
                      {formik2.touched.currentPassword && formik2.errors.currentPassword && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik2.errors.currentPassword}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-lg-4'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='newpassword' className='form-label fs-6 fw-bolder mb-3'>
                        New Password
                      </label>
                      <input
                        type='password'
                        className='form-control form-control-lg form-control-solid '
                        id='newpassword'
                        {...formik2.getFieldProps('newPassword')}
                      />
                      {formik2.touched.newPassword && formik2.errors.newPassword && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik2.errors.newPassword}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-lg-4'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='confirmpassword' className='form-label fs-6 fw-bolder mb-3'>
                        Confirm New Password
                      </label>
                      <input
                        type='password'
                        className='form-control form-control-lg form-control-solid '
                        id='confirmpassword'
                        {...formik2.getFieldProps('passwordConfirmation')}
                      />
                      {formik2.touched.passwordConfirmation && formik2.errors.passwordConfirmation && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik2.errors.passwordConfirmation}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className='form-text mb-5'>
                  {/* Password must be at least 8 character and contain symbols */}
                </div>

                <div className='d-flex'>
                  <button
                    id='kt_password_submit'
                    type='submit'
                    className='btn btn-primary me-2 px-6'
                  >
                    {'Update Password'}
                    {passwordLoading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  {/* <button
                  onClick={() => {
                    setPasswordForm(false)
                  }}
                  id='kt_password_cancel'
                  type='button'
                  className='btn btn-color-gray-400 btn-active-light-primary px-6'
                >
                  Cancel
                </button> */}
                </div>
              </form>
            </div>

            <div
              id='kt_signin_password_button'
              className={'ms-auto ' + (showPasswordForm && 'd-none')}
            >
              <button
                onClick={() => {
                  setPasswordForm(true)
                }}
                className='btn btn-light btn-active-light-primary'
              >
                Reset Password
              </button>
            </div>
          </div>

          {/* <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-6'>
          <KTSVG
            path='/media/icons/duotune/general/gen048.svg'
            className='svg-icon-2tx svg-icon-primary me-4'
          />
          <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
            <div className='mb-3 mb-md-0 fw-bold'>
              <h4 className='text-gray-800 fw-bolder'>Secure Your Account</h4>
              <div className='fs-6 text-gray-600 pe-7'>
                Two-factor authentication adds an extra layer of security to your account. To log
                in, in addition you'll need to provide a 6 digit code
              </div>
            </div>
            <a
              href='#'
              className='btn btn-primary px-6 align-self-center text-nowrap'
              data-bs-toggle='modal'
              data-bs-target='#kt_modal_two_factor_authentication'
            >
              Enable
            </a>
          </div>
        </div> */}
          {showModal && (
            <MessageModal2
              showModal={showModal}
              setShowModal={setShowModal}
              message={message}
              error={error}
            />
          )}
        </div>
      </div>
    </div>
  )
}

const MessageModal2 = ({showModal, setShowModal, message, error}) => {
  const navigate = useNavigate()
  return (
    <>
      {' '}
      <>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          <div className='modal-dialog modal-dialog-centered mw-550px'>
            <div className='modal-content'>
              <div className='modal-body scroll-y '>
                <div className='modal-header'>
                  <h5 className='modal-title fs-2'>{error ? 'Error' : 'Success'}</h5>
                  {/* <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                      onClick = {()=> setShowModal(false)}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div> */}
                </div>
                <div className='modal-body fs-3'>
                  <p>{message}</p>
                </div>
                <div className='modal-footer'>
                  {/* <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                      Close
                    </button> */}
                  <button
                    onClick={() => {
                      setShowModal(false)
                      window.location.reload()
                    }}
                    type='button'
                    className='btn btn-primary'
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-backdrop fade show'></div>
      </>
    </>
  )
}

const MessageModal = ({showModal, setShowModal, message, error}) => {
  const navigate = useNavigate()
  return (
    <>
      {' '}
      <>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          <div className='modal-dialog modal-dialog-centered mw-550px'>
            <div className='modal-content'>
              <div className='modal-body scroll-y '>
                <div className='modal-header'>
                  <h5 className='modal-title fs-2'>{error ? 'Error' : 'Success'}</h5>
                  {/* <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                      onClick = {()=> setShowModal(false)}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div> */}
                </div>
                <div className='modal-body fs-3'>
                  <p>{message}</p>
                </div>
                <div className='modal-footer'>
                  {/* <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                      Close
                    </button> */}
                  <button
                    onClick={() => {
                      setShowModal(false)
                      window.location.reload()
                    }}
                    type='button'
                    className='btn btn-primary'
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-backdrop fade show'></div>
      </>
    </>
  )
}

export {ProfileDetails}
